var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"250px"}},[_c('div',{staticClass:"flex items-center"},[_c('input',_vm._g(_vm._b({attrs:{"type":"text","placeholder":_vm.field.placeholder,"disabled":_vm.loading},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),{
          ..._vm.$listeners,
          input: (event) => _vm.handleInput('input', event.target.value),
        })),(_vm.loading)?_c('c-spinner',{staticStyle:{"margin-left":"-40px"},attrs:{"size":"sm"}}):_vm._e()],1),(_vm.errorMessage)?_c('div',{staticClass:"error-message"},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }